import { render } from "./ExpensesForm.vue?vue&type=template&id=a42e6ab8&scoped=true"
import script from "./ExpensesForm.vue?vue&type=script&lang=js"
export * from "./ExpensesForm.vue?vue&type=script&lang=js"

import "./ExpensesForm.vue?vue&type=style&index=0&id=a42e6ab8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42e6ab8"]])

export default __exports__